module.exports = __webpack_public_path__ + "img/alabama-guard-logo.9911ffe4.jpg";